import {
  Box,
  Flex,
  Text,
  VStack,
  Link,
  useColorModeValue,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { GoShieldCheck } from "react-icons/go";

export function InsuranceCardOverview() {
  const bgColor = useColorModeValue("blue.600", "blue.800");
  const textColor = useColorModeValue("gray.700", "gray.200");
  const linkColor = useColorModeValue("secondary", "blue.300");
  const boxBgColor = useColorModeValue("gray.100", "gray.700");

  const textStyle = {
    fontFamily: "'Lexend Deca', sans-serif",
  };

  return (
    <Box
      maxW={{ base: "100%", md: "md" }}
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      boxShadow="lg"
      fontFamily="'Lexend Deca', sans-serif"
      m={{ base: 2, md: 4 }}
      hidden
    >
      <Flex
        bg={bgColor}
        p={{ base: 3, md: 4 }}
        alignItems="center"
        flexDirection={{ base: "column", sm: "row" }}
        textAlign={{ base: "center", sm: "left" }}
      >
        <GoShieldCheck color="white" size="36px" />
        <Text
          color="white"
          fontWeight="bold"
          ml={{ base: 0, sm: 4 }}
          fontSize={{ base: "lg", md: "2xl" }}
          mt={{ base: 2, sm: 0 }}
          {...textStyle}
        >
          Seguro:
        </Text>
      </Flex>
      <Flex
        p={{ base: 3, md: 4 }}
        flexDirection={{ base: "column", sm: "row" }}
        alignItems="center"
      >
        <VStack
          flex={1}
          pr={{ base: 0, sm: 4 }}
          align="center"
          justify="center"
          mb={{ base: 4, sm: 0 }}
        >
          <Text
            fontWeight="bold"
            fontSize={{ base: "xs", md: "sm" }}
            color={textColor}
            textAlign="center"
            {...textStyle}
          >
            VALOR DO SEGURO:
          </Text>
          <Text
            fontWeight="bold"
            fontSize={{ base: "2xl", md: "xl" }}
            color="secondary"
            {...textStyle}
          >
            R$ 257,38
          </Text>
        </VStack>
        <Box
          flex={2}
          bg={boxBgColor}
          p={{ base: 3, md: 4 }}
          borderRadius="md"
          boxShadow="lg"
          w="100%"
          textAlign={{ base: "center", sm: "left" }}
        >
          <VStack align={{ base: "center", sm: "start" }} spacing={2}>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              fontWeight="bold"
              color={textColor}
              {...textStyle}
            >
              Saiba mais sobre as coberturas do Seguro FGTS
            </Text>
            <UnorderedList
              fontSize={{ base: "sm", md: "md" }}
              color={textColor}
              textAlign={{ base: "center", sm: "left" }}
              {...textStyle}
            >
              <ListItem>Morte</ListItem>
              <ListItem>
                Invalidez Permanente Total por Acidente – IPTA
              </ListItem>
            </UnorderedList>
            <Link
              href="#"
              color={linkColor}
              fontSize={{ base: "sm", md: "md" }}
              textAlign={{ base: "center", sm: "left" }}
              {...textStyle}
            >
              Para mais infos acesse: Cláusulas do Seguro
            </Link>
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
}
